"use client";

import { useSyncExternalStore } from "react";
import { featureGuestTranscription } from "@/lib/config";

function subscribe(onStoreChange: () => void) {
  window.addEventListener("storage", onStoreChange);
  return () => window.removeEventListener("storage", onStoreChange);
}

function getAccountSnapshot() {
  try {
    return Boolean(
      window.localStorage.getItem("token")
      || (featureGuestTranscription && window.localStorage.getItem("transcripta_guest_token")),
    );
  } catch {
    return false;
  }
}

function getServerAccountSnapshot() {
  return false;
}

/**
 * Keeps the server and first client snapshot identical, then re-checks local
 * account state after hydration. This prevents auth CTAs from changing the
 * rendered tree during hydration while still reacting to cross-tab auth changes.
 */
export function useAccountPresence() {
  return useSyncExternalStore(subscribe, getAccountSnapshot, getServerAccountSnapshot);
}
